exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nstrong[data-v-3f960b67] {\n    font-weight: 500;\n}\n", ""]);

// exports
